import { add, del, getViews, upd } from "@/Api/DepartmentController";
import { numProps, strProps } from "@/Common/Table/column";
import EditTable from "@/Common/Table/EditTable";
import { ColumnType } from "@/Common/Table/type";
import { Department } from "@/Models/Tables/Department";
import { useMemo } from "react";
import Add from "./Add";

function getColumns(): ColumnType<Department>[] {
    return [
        numProps("id", "Id", 80, true),
        strProps("code", "部门编码", 120, true, true),
        strProps("name", "部门名称", 160, true, true),
        strProps("remark", "备注", 200, true, true),
    ];
}

export default Index;
function Index() {
    const columns = useMemo(getColumns, []);
    return <EditTable< Department> getData={getViews}
        baseColumns={columns}
        isRank
        AddDom={Add}
        updDataHandle={upd}
        delDataHandle={s => del(s.id)}
        updMerge={updMerge}
        addDataHandle={add}
        rowKey={"id"}
    />;
}

function updMerge(source: Department, target: Department) {
    target.id = source.id;
    return target;
}